<template>
  <v-dialog
    v-model="open"
    persistent
    max-width="768px"
    :fullscreen="isMobileBreakpoint"
  >
    <v-card max-height="516px">
      <v-toolbar
        flat
        class="px-2"
        elevation="0"
        :class="[isMobileBreakpoint ? 'px-3' : 'px-2']"
      >
        <v-toolbar-title
          v-if="step === 2"
          class="body-regular-medium font-weight-medium"
          :class="{ 'neutral-20-dark--text': !$vuetify.theme.dark }"
          style="line-height: 120%; white-space: normal"
        >
          Selecione a plataforma para iniciar a integração DRM Watermark
        </v-toolbar-title>
        <v-spacer />
        <v-icon
          @click="close"
          class="close-icon"
          size="24"
          color="grey"
          style="cursor: pointer"
        >
          mdi-close
        </v-icon>
      </v-toolbar>
      <v-card-text
        class="text-center"
        :class="[
          step === 1 ? 'mt-12' : 'mt-0 pt-0',
          isMobileBreakpoint && step === 2 ? 'pa-5' : 'pa-7',
        ]"
        :style="
          isMobileBreakpoint
            ? { height: 'calc(100vh - 80px)', overflowY: 'auto' }
            : {}
        "
      >
        <template v-if="canShowStep1">
          <simple-svg
            :src="require('@/assets/pandaIcons/drm-on-gradient.svg')"
            width="64px"
          />
          <div
            class="body-bold-medium neutral-20-dark--text mt-4 mb-6"
            :style="{
              'white-space': isMobileBreakpoint ? 'pre-line' : 'normal',
            }"
          >
            {{ $t('message.pages.drm.integrationSelector.title') }}
          </div>
          <div
            class="body-regular-small neutral-40-light--text mb-6"
            :class="isMobileBreakpoint ? 'px-5' : 'px-14'"
          >
            <p class="mb-2" style="white-space: pre-line">
              {{ $t('message.pages.drm.integrationSelector.description') }}
            </p>
            <p>
              {{ $t('message.pages.drm.integrationSelector.linkPrefix') }}
              <a
                :href="$t('message.pages.drm.integrationSelector.link')"
                target="_blank"
                rel="noopener"
                class="brand-60-base--text body-bold-small"
                style="text-decoration: none"
              >
                {{
                  $t('message.pages.drm.integrationSelector.linkDescription')
                }}
                <v-icon size="14px" class="brand-60-base--text mb-1">
                  mdi-open-in-new
                </v-icon>
              </a>
            </p>
          </div>
          <base-btn
            v-if="!isMobileBreakpoint"
            @click="nextStep"
            class="body-regular-small mb-16"
          >
            {{ $t('message.pages.drm.integrationSelector.action') }}
          </base-btn>
        </template>
        <template v-else>
          <v-row
            class="d-flex flex-wrap px-2"
            :class="{ 'platforms-mobile': isMobileBreakpoint }"
            style="gap: 16px 24px"
          >
            <div
              v-for="platform in platforms"
              :key="platform.value"
              class="platform-card-wrapper"
              :class="`platform-card-wrapper--${platform.value}`"
              @click="selectPlatform(platform)"
            >
              <v-card outlined class="d-flex align-center platform-card">
                <img :src="platform.icon" width="40" />
                <span class="ml-3">{{ platform.label }}</span>
              </v-card>
            </div>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions
        v-if="canShowStep1 && isMobileBreakpoint"
        class="py-4 px-6 card-actions"
      >
        <base-btn @click="nextStep" style="width: 100%">
          {{ $t('message.pages.drm.integrationSelector.action') }}
        </base-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DrmIntegrationSelector',
  data() {
    return {
      step: 1,
      open: false,
      firstAccess: false,
      platforms: [
        {
          value: 'cademi',
          label: 'Cademí',
          icon: require('@/assets/pandaIcons/plataformas-cademi.svg'),
        },
        {
          value: 'ticto',
          label: 'Ticto',
          icon: require('@/assets/pandaIcons/plataformas-ticto.svg'),
        },
        {
          value: 'eduzz',
          label: 'Eduzz',
          icon: require('@/assets/pandaIcons/plataformas-eduzz.svg'),
        },
        {
          value: 'the-members',
          label: 'The Members',
          icon: require('@/assets/pandaIcons/plataformas-the-members.svg'),
        },
        {
          value: 'hotmart',
          label: 'Hotmart',
          icon: require('@/assets/pandaIcons/plataformas-hotmart.svg'),
        },
        {
          value: 'xgrow',
          label: 'XGrow',
          icon: require('@/assets/pandaIcons/plataformas-xgrow.svg'),
        },
        // {
        //   value: 'memberkit',
        //   label: 'Memberkit',
        //   icon: require('@/assets/pandaIcons/plataformas-memberkit.svg'),
        // },
        {
          value: 'api',
          label: 'Outra (API)',
          icon: require('@/assets/pandaIcons/plataformas-api.svg'),
        },
      ],
    }
  },
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    canShowStep1() {
      return !this.firstAccess && this.step === 1
    },
  },
  mounted() {
    this.$root.$on('drmIntegrationSelector', () => {
      this.checkAccess()
      this.hideCrispButton()
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('drmIntegrationSelector')
    this.showCrispButton()
  },
  methods: {
    checkAccess() {
      const userKey = `drmFirstAccess_${this.userInfo.sub}`
      const alreadyAccessed = localStorage.getItem(userKey)

      if (!alreadyAccessed) {
        this.step = 1
      } else {
        this.step = 2
      }
    },
    nextStep() {
      const userKey = `drmFirstAccess_${this.userInfo.sub}`
      localStorage.setItem(userKey, 'true')
      this.step = 2
    },
    selectPlatform(platform) {
      this.$root.$emit('drmIntegrationFlow', platform.value)
      this.open = false
    },
    close() {
      this.open = false
      this.showCrispButton()
    },
    hideCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton && this.isMobileBreakpoint) {
        crispButton.style.setProperty('display', 'none', 'important')
      }
    },
    showCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton) {
        crispButton.style.removeProperty('display')
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .v-dialog {
  overflow: hidden !important;
}

::v-deep .v-toolbar {
  height: 80px !important;

  .v-toolbar__content {
    height: 80px !important;
  }
}

::v-deep .platform-card-wrapper--api svg {
  width: 40px !important;
  height: 40px !important;

  path {
    fill: varFigma(neutral-60) !important;
  }
}

.platform-card-wrapper {
  flex: 0 1 calc(50% - 12px);
}

.platform-card {
  height: 96px;
  padding: 27px;
  cursor: pointer;
  border-radius: var(--spacing-02, 4px);
  border: 1px solid varFigma(neutral-95-lightest);
  transition: background-color 0.2s ease, border 0.2s ease;

  &:hover {
    background-color: varFigma(brand-99-lightest);
    border: 1px solid varFigma(brand-80-light);
  }
}

@media (max-width: 768px) {
  .platform-card-wrapper {
    flex: 0 1 100%;
  }

  .platforms-mobile {
    margin-top: 28px !important;
    padding: 0 20px !important;
  }

  .card-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: varFigma(neutral-100-white);
    border-top: 1px solid varFigma(neutral-95-lightest);
    padding: 16px;
  }
}
</style>
